var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dp-container',{attrs:{"fluid":false,"container":{
    cols: 12,
    sm: 12,
    md: 8,
    offsetMd: 2,
    lg: 6,
    offsetLg: 3,
    xl: 6,
    offsetXl: 3,
  },"col-class":"panel-wrapper px-4 py-4"}},[_c('section',{staticClass:"mb-3"},[_c('b-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: _vm.redirectPath, params: _vm.redirectParams }},domProps:{"textContent":_vm._s(_vm.$t('productConfigBackLink.Back'))}})],1),_c('dp-loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_c('dp-add-a-pet-form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"form",attrs:{"all-breeds":{ catBreeds: _vm.breedsCat, dogBreeds: _vm.breedsDog },"existing-pet-names":_vm.getAllActivePetNames,"inactive-pet-names":_vm.getAllInactivePetNames,"duplicate-pet-name":_vm.duplicatePetName,"duplicate-pet-message":_vm.getError,"customer-support-phone":_vm.customerSupportPhone,"continue-button-label":"Save and Add Photo"},on:{"addPet":_vm.addPetAndAssign}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }